export default {
  panels: {
    layer: 'Layers'
  }
}
